<template>
<v-menu offset-y v-model="menuVisible" :position-x="x" :position-y="y" absolute offset-y>
	<v-list>
		<template v-for="(action, index) in actions">
			<v-list-tile  v-bind:is="action" :row="row"></v-list-tile>
		</template>
	</v-list>
</v-menu>
</template>

<script>
import Vuex from 'vuex'
import { Entity } from '@/assets/js/JMan/Entity'
import * as Actions from './RowActionWidgets'

export default {
	name: "JmRowActions",

	data () {
		return {
			menuVisible: false
		}
	},

	watch: {
		menuRequested (value) {
			this.menuVisible = value;
		},

		menuVisible (value) {
			if (!value && this.menuRequested) {
				this.$store.commit('dialogue/actions/toggle');
			}
		}
	},

	computed: {

		...Vuex.mapState({
			menuRequested: (state) => state.dialogue.actions.menuVisible,
			x: (state) => state.dialogue.actions.x,
			y: (state) => state.dialogue.actions.y,
			entity: (state) => state.dialogue.actions.entity,
		}),

		row () {
			// Fake a row.
			// FIXME Row actions need to take entity, not row as argument
			return {
				entity: this.entity
			};
		},

		type () {
			return this.row.entity.type;
		},

		actions () {
			return this.$store.state.tables.actions[this.type] || [];
		}

	},

	components: {
		...Actions
	}

};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/RowActions.vue